import { Avatar, Chip, useMediaQuery, useTheme } from '@mui/material'
import { StickyTableLeftCell } from '../../styles/TableStyles'
import { Project } from '../../store/types'
import { getImageSrc } from '../../store/utils'
import { generatePath, useNavigate } from 'react-router-dom'
import navigation from '../../config/navigation'
import React, { RefObject } from 'react'

const ProjectTitleTableCell = ({
  onRemoveIconClick,
  project,
  isEditionDisabled,
  index,
  firstProjectRef,
  vacancyRef,
}: {
  project: Project
  onRemoveIconClick: () => void
  isEditionDisabled: boolean
  index: number
  firstProjectRef: RefObject<HTMLDivElement>
  vacancyRef: RefObject<HTMLButtonElement>
}) => {
  const navigate = useNavigate()
  const theme = useTheme()
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'))
  const handleChipClick = (event: React.MouseEvent) => {
    const chipLabel = event.currentTarget.querySelector('.MuiChip-label')
    const chipAvatar = event.currentTarget.querySelector('.MuiAvatar-root')

    if (chipLabel && chipLabel.contains(event.target as Node)) {
      navigate(generatePath(navigation.projectDetails, { id: project.id }))
    } else if (chipAvatar && chipAvatar.contains(event.target as Node)) {
      navigate(generatePath(navigation.projectDetails, { id: project.id }))
    }
  }
  return (
    <StickyTableLeftCell
      padding="checkbox"
      sx={{ width: '121px', borderBottom: '1px solid', borderColor: 'background.elevation8', zIndex: 2 }}
    >
      <Chip
        ref={index === 0 ? firstProjectRef : null}
        color="default"
        label={
          isDownSm
            ? project.acronym.length > 7
              ? project.acronym.substring(0, 7) + '...'
              : project.acronym
            : project.acronym
        }
        onDelete={!isEditionDisabled ? onRemoveIconClick : undefined}
        onClick={handleChipClick}
        onKeyDown={event => {
          if (event.key === 'Enter' || event.key === ' ') {
            navigate(generatePath(navigation.projectDetails, { id: project.id }))
          }
          if (event.key === 'Tab' && event.shiftKey && index === 0) {
            event.preventDefault()
            vacancyRef.current?.focus()
          }
        }}
        size="small"
        variant="outlined"
        avatar={
          <Avatar
            src={getImageSrc(project.avatar, project.extension)}
            alt={`${project.name}-resourcing-project-avatar`}
            sx={{ backgroundColor: 'background.elevation8' }}
          />
        }
        sx={{
          '& .MuiChip-avatarSmall': {
            fontSize: '0.70rem',
          },
          '.MuiChip-label': { p: 0, mx: 1 },
          '& .MuiChip-deleteIcon': {
            visibility: 'hidden',
          },
          '&:hover': {
            '& .MuiChip-deleteIcon': {
              visibility: isEditionDisabled ? 'hidden' : 'visible',
            },
          },
          ':focus': {
            '& .MuiChip-deleteIcon': {
              visibility: isEditionDisabled ? 'hidden' : 'visible',
            },
          },
        }}
      />
    </StickyTableLeftCell>
  )
}

export default ProjectTitleTableCell